export { default as GuestRoute } from './GuestRoute';
export { default as PrivateRoute } from './PrivateRoute';



// WEBPACK FOOTER //
// ./src/components/Routes/index.ts